<!-- 日期搜索框 -->
<template>
    <div id="date-select">

        <div @click="show(1)" class="date-select-year" style="margin-left: 0px">
            <p>{{yearsModel}}</p>
            <VuePicker :data="years"
                       :showToolbar="true"
                       @cancel="cancel"
                       @confirm="confirm"
                       :visible.sync="yearPickerVisible"
            />
            <img src="../assets/down.png"/>
        </div>

        <div @click="show(2)" class="date-select-year">
            <p>{{monthsModel}}</p>
            <VuePicker :data="months"
                       :showToolbar="true"
                       @cancel="cancel"
                       @confirm="confirm"
                       :visible.sync="monthPickerVisible"
            />
            <img src="../assets/down.png"/>
        </div>

        <div @click="show(3)" class="date-select-year">
            <p>{{daysModel}}</p>
            <VuePicker :data="days"
                       :showToolbar="true"
                       @cancel="cancel"
                       @confirm="confirm"
                       :visible.sync="dayPickerVisible"
            />
            <img src="../assets/down.png"/>
        </div>

        <div style="clear:both;"></div>

    </div>
</template>

<script>
    import VuePicker from 'vue-pickers'

    var yearData = [];
    var monthData = [];
    var dayData = [];

    export default {
        name: "DateSelectComponents",

        components: {
            VuePicker
        },
        props: ['yearInfo', 'monthInfo', 'dayInfo'],

        data() {
            return {
                yearsModel: null,
                years: [
                    yearData
                ],
                monthsModel: null,
                months: [
                    monthData
                ],
                daysModel: null,
                days: [
                    dayData
                ],

                yearPickerVisible: false,
                monthPickerVisible: false,
                dayPickerVisible: false,
            }
        },

        created() {
            this.init();
        },

        methods: {

            show (value) {
                if (value === 1) {
                    this.yearPickerVisible = true
                } else if (value === 2) {
                    this.monthPickerVisible = true
                } else {
                    this.dayPickerVisible = true
                }
            },

            cancel () {
                this.result = 'click cancel result: null'
            },

            confirm (res) {
                let _this = this;
                if (this.yearPickerVisible) {
                    _this.yearsModel = res[0].value;
                    _this.dateChange(1)
                } else if (this.monthPickerVisible) {
                    _this.monthsModel = res[0].value;
                    _this.dateChange(2)
                } else {
                    _this.daysModel = res[0].value;
                    _this.dateChange(3)
                }
                console.log(JSON.stringify(res))
            },

            init() {
                var myDate = new Date;
                var year = myDate.getFullYear();//获取当前年
                var month = myDate.getMonth() + 1;//获取当前月
                var day = myDate.getDate();//获取当前日

                this.initSelectYear(year)
                this.initSelectMonth();
                this.initSelectDay(year, month);
                this.yearsModel = year;
                this.monthsModel = month;
                this.daysModel = day;
                let obj = {year: this.yearsModel, month: this.monthsModel, day: this.daysModel}
                this.$parent.dateChange(obj);
            },
            initSelectYear(year) {

                for (let i = 0; i < 100; i++) {
                    yearData.push({value: (year - i), label: (year - i) + "年"});
                }
            },
            initSelectMonth() {

                for (let i = 1; i <= 12; i++) {
                    monthData.push({value: i, label: i + "月"});
                }
            },
            initSelectDay(year, month) {

                var maxDay = this.getMaxDay(year, month);
                for (var i = 1; i <= maxDay; i++) {
                    dayData.push({value: i, label: i + "日"});
                }
            },
            dateChange(type) {
                //1年 2月 3日 4 左 5右
                if (type === 1 || type === 2) {
                    if (this.monthsModel === 0) {
                        this.daysModel = 0;
                        this.initSelectDay(this.yearsModel, 1);
                    } else {
                        this.initSelectDay(this.yearsModel, this.monthsModel);
                    }
                }
                if (type === 4) {
                    this.dayleft();
                }
                if (type === 5) {
                    this.dayright();
                }

                //操作父组件方法
                let obj = {year: this.yearsModel, month: this.monthsModel, day: this.daysModel}
                this.$parent.dateChange(obj);

            },
            dayleft() {

                var tmpYear = this.yearsModel;
                var tmpMonth = this.monthsModel;
                var tmpDay = this.daysModel;
                if (tmpYear == null) {
                    var myDate = new Date;
                    var year = myDate.getFullYear();//获取当前年
                    var month = myDate.getMonth() + 1;//获取当前月
                    var day = myDate.getDate();//获取当前日
                    this.yearsModel = year;
                    this.monthsModel = month;
                    this.daysModel = day;
                    return;
                }
                if (tmpMonth == null) {
                    tmpMonth = 0
                }
                if (tmpDay == null) {
                    tmpDay = 0
                }

                var yearV = tmpYear;
                var monthV = tmpMonth;
                var dayV = tmpDay;

                if ((tmpMonth === 0 || tmpMonth === 1) && (tmpDay === 0 || tmpDay === 1)) {
                    yearV = tmpYear - 1;
                    monthV = 12;
                    dayV = this.getMaxDay(tmpYear, tmpMonth);
                }
                if (!(tmpMonth === 0 || tmpMonth === 1) && (tmpDay === 0 || tmpDay === 1)) {
                    monthV = tmpMonth - 1;
                    dayV = this.getMaxDay(tmpYear, tmpMonth);
                }
                if ((tmpMonth === 0 || tmpMonth === 1) && !(tmpDay === 0 || tmpDay === 1)) {
                    dayV = tmpDay - 1;
                }
                if (!(tmpMonth === 0 || tmpMonth === 1) && !(tmpDay === 0 || tmpDay === 1)) {
                    dayV = tmpDay - 1;
                }
                this.yearsModel = yearV;
                this.monthsModel = monthV;
                this.daysModel = dayV;
            },
            dayright() {

                var myDate = new Date;
                var year = myDate.getFullYear();//获取当前年
                var month = myDate.getMonth() + 1;//获取当前月
                var day = myDate.getDate();//获取当前日

                var tmpYear = this.yearsModel;
                var tmpMonth = this.monthsModel;
                var tmpDay = this.daysModel;

                if (tmpYear == null) {
                    this.yearsModel = year;
                    this.monthsModel = month;
                    this.daysModel = day;
                    return;
                }

                if (tmpMonth == null) {
                    tmpMonth = 0
                }
                if (tmpDay == null) {
                    tmpDay = 0
                }
                if (tmpYear > year) {
                    this.yearsModel = year;
                    this.monthsModel = month;
                    this.daysModel = day;
                    return;
                }
                if (tmpYear === year) {
                    if ((tmpMonth > month || tmpMonth === 0) || (tmpMonth === month) && (tmpDay >= day || tmpDay === 0)) {
                        this.yearsModel = year;
                        this.monthsModel = month;
                        this.daysModel = day;
                        return;
                    }
                }

                var maxDay = this.getMaxDay(tmpYear, tmpMonth);
                var yearV = tmpYear;
                var monthV = tmpMonth;
                var dayV = tmpDay;

                if ((tmpMonth === 0 || tmpMonth === 12) && (tmpDay === 0 || tmpDay === maxDay)) {
                    yearV = tmpYear + 1;
                    monthV = 1;
                    dayV = 1;
                }
                if (!(tmpMonth === 0 || tmpMonth === 12) && (tmpDay === 0 || tmpDay === maxDay)) {
                    monthV = tmpMonth + 1;
                    dayV = 1;
                }
                if (!(tmpMonth === 0 || tmpMonth === 12) && !(tmpDay === 0 || tmpDay === maxDay)) {
                    dayV = tmpDay + 1;
                }

                this.yearsModel = yearV;
                this.monthsModel = monthV;
                this.daysModel = dayV;

            },
            getMaxDay(year, month) {
                var new_year = year;  //取当前的年份
                var new_month = month++;//取下一个月的第一天，方便计算（最后一天不固定）
                if (month > 12)      //如果当前大于12月，则年份转到下一年
                {
                    new_month -= 12;    //月份减
                    new_year++;      //年份增
                }
                var new_date = new Date(new_year, new_month, 1);//取当年当月中的第一天
                return (new Date(new_date.getTime() - 1000 * 60 * 60 * 24)).getDate();//获取当月最后一天日期
            }
        },

        watch: {
            yearInfo:{
                handler(value) {
                    this.yearsModel = value;
                }

            },
            monthInfo:{
                handler(value) {
                    this.monthsModel = value;
                }
            },
            dayInfo:{
                handler(value) {
                    this.daysModel = value;
                }
            },
        }
    }
</script>

<style lang="scss">
    #date-select {
        width: auto;
        margin-left: 10px;
        margin-right: 10px;
        margin-top: 20px;

        .date-select-year {
            width: 32%;
            height: 35px;
            background-color: white;
            border-radius: 5px;
            line-height: 5px;
            border: 2px solid #ffa9af;
            float: left;
            position: relative;
            margin-left: 5px;

            p {
                position: absolute;
                width: 100%;
            }
        }

        img {
            width: 13px;
            height: 8px;
            position: absolute;
            right: 5px;
            top: 12px;
        }
    }

    .btn {
        font-size: 1rem !important;
        border: none !important;
        padding: 10px 30px !important;
    }
</style>